<template>
  <div id="spin-create-event-wrapper">
    <heading
      class="spin-create-event-heading"
      :heading="heading"
      :subheading="subheading"
      :icon="eventCreationMethod ? 'left-arrow-single' : undefined"
      @icon-clicked="previousStep"
    />
    <component
      class="spin-create-event-slide"
      :is="component"
      :event="event"
      :chosenContact="chosenContact"
      :contactFields="contactFields"
      :chosenLocation="chosenLocation"
      @next="nextStep"
      @previous="previousStep"
      @method-chosen="methodChosen"
      @title-input="titleInput"
      @date-input="dateInput"
      @start-time-input="startTimeInput"
      @end-time-input="endTimeInput"
      @add-location="addLocation"
      @remove-location="removeLocation"
      @chosen-location="chosenLocation"
      @add-contact="addContact"
      @remove-contact="removeContact"
      @email-input="contactEmailInput"
      @first-name-input="contactFirstNameInput"
      @last-name-input="contactLastNameInput"
      @phone-number-input="contactPhoneNumberInput"
      @toggle-item="toggleItem"
    />
    <div id="spin-event-submission-section" v-if="eventCreationMethod">
      <h5>
        {{ buttonHeading }}
      </h5>
      <Button
        :text="buttonText"
        :disabled="buttonDisabled"
        :processing="processing"
        @click="buttonDisabled ? '' : nextStep()"
      />
    </div>
  </div>
</template>
<script>
import {
  formatTime,
  formatPrice,
  formatDate,
  // formatPhoneNumber,
  // productTotal,
  // subtotal,
  total,
  calculateEventTime,
  // balanceOutstanding,
  // calculateEventTime,
} from "../../../Helpers/invoice.js";

import Heading from "../../../Components/UI/Heading.vue";
import Button from "../../../Components/UI/Button.vue";
import EventCreationMethod from "./EventCreationMethod.vue";
import GuidedCreationLogistics from "./GuidedSteps/GuidedCreationLogistics.vue";
import GuidedCreationInvoiceItems from "./GuidedSteps/GuidedCreationInvoiceItems.vue";
import GuidedCreationInclusions from "./GuidedSteps/GuidedCreationInclusions.vue";
import GuidedCreationLocation from "./GuidedSteps/GuidedCreationLocation.vue";
import GuidedCreationContact from "./GuidedSteps/GuidedCreationContact.vue";
import GuidedCreationReview from "./GuidedSteps/GuidedCreationReview.vue";
export default {
  data() {
    return {
      processing: false,
      event: {
        api_version: "9-28-2022",
        contacts: [],
        contracts: [],
        book_date: new Date(),
        date: new Date(),
        start_time: null,
        end_time: null,
        forms: [],
        invoice_adjustments: [],
        invoice_payments: [],
        invoice_products: [],
        locations: [],
        notes: [],
        title: [],
        time_zone: null,
      },
      chosenLocation: undefined,
      timeZone: undefined,
      chosenContact: undefined,
      contactFields: {
        email: null,
        phoneNumber: null,
        given_name: null,
        family_name: null,
      },
      eventCreationMethod: "Guided",
      eventCreationStep: 1,
      eventCreationMethods: {
        Guided: {
          1: {
            heading: "Logistics and such",
            subheading: "Step 1 of 5",
            component: "GuidedCreationLogistics",
            buttonText: "Looks Good",
          },
          2: {
            heading: "Here's the money",
            subheading: "Step 2 of 5",
            component: "GuidedCreationInvoiceItems",
            buttonText: "Sounds right",
          },
          3: {
            heading: "Standard inclusions",
            subheading: "Step 3 of 5",
            component: "GuidedCreationInclusions",
            buttonText: "About right",
          },
          4: {
            heading: "Where?",
            subheading: "Step 4 of 5",
            component: "GuidedCreationLocation",
            buttonText: "That's the spot",
          },
          5: {
            heading: "and who (whom?)",
            subheading: "Step 5 of 5",
            component: "GuidedCreationContact",
            buttonText: "Check it",
          },
          6: {
            heading: "Let's wrap this up",
            subheading: "Review",
            component: "GuidedCreationReview",
            buttonText: "Send it",
          },
        },
      },
    };
  },
  computed: {
    buttonHeading() {
      if (this.eventCreationMethod === "Guided") {
        switch (this.eventCreationStep) {
          case 1:
            if (
              this.event.date &&
              this.event.start_time &&
              this.event.end_time &&
              this.event.title
            ) {
              return `${formatDate(this.event.date)} from ${formatTime(
                this.event.start_time
              )} to ${formatTime(this.event.end_time)}`;
            } else {
              return "Input a date and time";
            }
          case 2:
            if (this.event.invoice_products.length > 0) {
              return `${formatPrice(
                total(this.event)
              )} for ${calculateEventTime(this.event)} hours`;
            } else {
              return "Choose a product";
            }
          case 3:
            return "Make sure it's what you need";
          case 4:
            if (this.chosenLocation) {
              return `Heading to ${
                this.chosenLocation.Name
                  ? this.chosenLocation.Name
                  : this.chosenLocation.name
              }?`;
            } else {
              return "Type to search for locations";
            }
          case 5:
            return "Ready to review?";
          case 6:
            return "All looking good?";
          default:
            return "Send it";
        }
      } else {
        return "Don't click this";
      }
    },
    heading() {
      if (this.eventCreationMethod === "Guided") {
        return this.eventCreationMethods[this.eventCreationMethod][
          this.eventCreationStep
        ]["heading"];
      } else {
        return "Event Creation Method";
      }
    },
    subheading() {
      if (this.eventCreationMethod === "Guided") {
        return this.eventCreationMethods[this.eventCreationMethod][
          this.eventCreationStep
        ]["subheading"];
      } else {
        return "Event Creation Method";
      }
    },
    component() {
      if (this.eventCreationMethod === "Guided") {
        return this.eventCreationMethods[this.eventCreationMethod][
          this.eventCreationStep
        ]["component"];
      } else {
        return "EventCreationMethod";
      }
    },
    buttonText() {
      return this.eventCreationMethods[this.eventCreationMethod][
        this.eventCreationStep
      ]["buttonText"];
    },
    buttonDisabled() {
      switch (this.eventCreationStep) {
        case 1:
          if (
            this.event.title &&
            this.event.date &&
            this.event.start_time &&
            this.event.end_time
          ) {
            return false;
          } else {
            return true;
          }
        case 2:
          return this.event.invoice_products.length <= 0;
        case 4:
          return !this.chosenLocation;
        case 5:
          return !(
            (this.contactFields.email &&
              this.contactFields.phoneNumber &&
              this.contactFields.given_name &&
              this.contactFields.family_name) ||
            this.chosenContact
          );
        default:
          return false;
      }
    },
  },
  methods: {
    methodChosen(method) {
      switch (method) {
        case "Guided":
          this.eventCreationMethod = "Guided";
          break;
        default:
          break;
      }
    },
    nextStep() {
      switch (this.eventCreationStep) {
        case 6:
          this.createEvent();
          break;
        default:
          this.eventCreationStep++;
          break;
      }
    },
    previousStep() {
      switch (this.eventCreationStep) {
        case 1:
          this.eventCreationMethod = undefined;
          break;
        default:
          this.eventCreationStep--;
          break;
      }
    },
    resetFields() {
      this.event = {
        api_version: "9-28-2022",
        contacts: [],
        contracts: [],
        date: new Date(),
        start_time: null,
        end_time: null,
        forms: [],
        invoice_adjustments: [],
        invoice_payments: [],
        invoice_products: [],
        locations: [],
        notes: [],
        title: [],
        time_zone: null,
      };
      this.chosenLocation = undefined;
      this.timeZone = undefined;
      this.chosenContact = undefined;
      this.contactFields = {
        email: null,
        phoneNumber: null,
        given_name: null,
        family_name: null,
      };
      this.eventCreationMethod = undefined;
      this.eventCreationStep = 1;
    },
    titleInput(title) {
      this.event.title = title;
    },
    dateInput(input) {
      this.event.date = input;
      if (this.event.start_time) {
        let start = this.event.start_time;
        let date = new Date(date);
        date.setHours(start.getHours(), start.getMinutes());
        this.startTimeInput(date);
      }
      if (this.event.end_time) {
        let end = this.event.end_time;
        let date = new Date(input);
        date.setHours(end.getHours(), end.getMinutes());
        this.endTimeInput(date);
      }
    },
    startTimeInput(time) {
      this.event.start_time = time;
    },
    endTimeInput(time) {
      this.event.end_time = time;
      if (this.event.end_time < this.event.start_time) {
        this.event.end_time.setDate(this.event.end_time.getDate() + 1);
      }
    },
    addLocation(location) {
      this.chosenLocation = location;
      this.event.time_zone = location.TimeZone;
      switch (location.api_version) {
        case "9-28-2022":
          this.timeZone = location.TimeZone;
          break;
        default:
          break;
      }
    },
    removeLocation() {
      this.chosenLocation = {};
    },
    addContact(contact) {
      this.chosenContact = contact;
    },
    removeContact() {
      this.chosenContact = {};
    },
    contactEmailInput(value) {
      this.contactFields.email = value;
    },
    contactPhoneNumberInput(value) {
      this.contactFields.phoneNumber = value;
    },
    contactFirstNameInput(value) {
      this.contactFields.given_name = value;
    },
    contactLastNameInput(value) {
      this.contactFields.family_name = value;
    },

    checkEventForPresence(array, item) {
      if (item) {
        let index = this.event[array].findIndex((x) => {
          return item.id
            ? x.config_id === item.id
            : item.config_id
            ? x.config_id === item.config_id
            : x.name === item.name;
        });
        return index >= 0 ? index : false;
      }
    },
    toggleItem(array, item) {
      let index = this.checkEventForPresence(array, item);
      if (index !== false) {
        this.event[array].splice(index, 1);
      } else {
        let newItem = { ...item };
        if (newItem.id) {
          newItem.config_id = newItem.id;
        }
        delete newItem.id;
        this.event[array].push(newItem);
      }
    },
    async createEvent() {
      if (!this.chosenContact) {
        this.chosenContact = this.contactFields;
      }
      let params = {
        contact: this.chosenContact,
        location: this.chosenLocation,
        event: this.event,
      };
      this.processing = true;
      await this.$store.dispatch("addEvent", params);
      this.processing = false;
      this.resetFields();
    },
  },
  created() {
    this.resetFields();
    //  todo : create a creation queue for when events are submitted, so user can navigate away from the page while the event is being generated
    // todo : create event
    // - existing contact -> send invite email, and create invitation queue for user approval
  },
  components: {
    EventCreationMethod,
    Heading,
    Button,
    GuidedCreationLogistics,
    GuidedCreationInvoiceItems,
    GuidedCreationInclusions,
    GuidedCreationLocation,
    GuidedCreationContact,
    GuidedCreationReview,
  },
  props: [],
};
</script>
<style scoped>
@media screen {
  #spin-create-event-wrapper {
    width: 100%;
    height: fit-content;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
  }

  .spin-create-event-slide {
    height: 70%;
  }

  #spin-event-submission-section {
    height: 15%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  @media (min-width: 800px) {
    #spin-create-event-wrapper {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
    }

    .spin-create-event-heading {
      height: 15%;
    }

    .spin-create-event-slide {
      min-height: 60vh;
    }

    #spin-event-submission-section {
      height: 15%;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }
}
</style>
